<template>
  <b-row>
    <b-col cols="12">
      <email-notification-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import EmailNotificationAddForm from './EmailNotificationAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    EmailNotificationAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
